import React, { useEffect } from 'react'
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { useAuthState } from '../context/AuthContext';
import Home from '../components/home/Home';
import Contact from '../components/layouts/Contact';
import About from '../components/layouts/About';
import Landing from '../components/Landing';
import Service from '../components/layouts/Service';
import Login from '../components/auth/Login';


function Router() {

    const {state, dispatch} = useAuthState();
    const navigate = useNavigate();

    useEffect(() => {
        if(JSON.parse(localStorage.getItem("token")) !== undefined){
            dispatch({type: "active"});
        }else{
            navigate("/login", { replace: true });
        }
    },[dispatch]);

    return( 
        <Routes>

            <Route path="/" element={<Landing />}>
                <Route path="/" element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="contact" element={ <Contact /> } />
                <Route path="service" element={ <Service /> } />
                <Route path="login" element={ <Login /> } />
                {/* <Route
                    path="/reference"
                    element={
                    <ReferenceContext>
                        <Reference />
                    </ReferenceContext>
                    }
                /> */}
            </Route>

        
                         
        </Routes>
    );
}

export default Router;
